import React from "react";
import contextProvider from "../../../contextProvider";
import { Row, Col, Badge } from "reactstrap";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";
import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOCollapse from "../../../_L1_components/Elements/ReactOCollapse";
import Section from "../../../_L1_components/Layout/Section";
import Panel from "../../../_L1_components/Layout/Panel";
import { Link } from "react-router-dom";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

const context_exposed_methods = [];

class SmartView extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
      filteredData: [],
      infoText: false,
      countTag: [],
      selectedTags: [],
      initOpen: false,
      showTags: true,
      // searchKey: "",
    };
    super(props, initState);

    this.apiStore = null;
    this.actionsShelf = null;
    this._essid_sorting = "asc";
    this._autorefresh = null;
    this._advanced_collapse_opened3 = null;
    this.urlParams = new URLSearchParams(window.location.search);
    this.orderedTags = [];
    this.noTagCount = 0;
  }

  onComponentDidMount() {
    if (this.getAppContext().getLocalStorageService().get("goBackExplorer")) {
      this.getAppContext().getLocalStorageService().remove("goBackExplorer");
    }
    this.mounted = true;
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    this.loadDiag();
    this._reload_form.init();
    this.showTags_form.init();
  }

  countOfflineProbes(data) {
    let filtered = data.filter((d) => d.sync_status == 0);
    return filtered.length;
  }

  filterDataAnomalies(d) {
    return (
      (d.diag == "N" && d.explicit_mac == "yes") ||
      (d.color != "success" && d.diag != "N")
    );
  }

  hasMatchingTag(arrayOfTags, selectedTags) {
    return selectedTags.some((tag) => arrayOfTags.includes(tag));
  }
  handleMeasuresWithoutTags(value) {
    const newFilteredData =
      value == "on"
        ? this.state.data.online.filter((item) => item.tags == "")
        : this.state.data.online;
    this.formatAnomaliesData(newFilteredData);
    this.setState({ filteredData: newFilteredData });
  }
  handleTagClick = (tag) => {
    if (this.getAppContext().getLocalStorageService().get("goBackTags")) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
    }
    this.setState((prevState) => {
      const alreadySelected = prevState.selectedTags.includes(tag);
      const newSelectedTags = alreadySelected
        ? prevState.selectedTags.filter((t) => t !== tag)
        : [...prevState.selectedTags, tag];

      const newFilteredData = this.state.data.online.filter((item) => {
        let tags = item.tags || "";
        const itemTags = tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);
        return newSelectedTags.every((selectedTag) =>
          itemTags.includes(selectedTag),
        );
      });

      this.formatAnomaliesData(newFilteredData);
      let counterAnomalies = newFilteredData.filter(
        (d) => d.color != "success",
      ).length;

      if (counterAnomalies == 0) {
        if (!this.state._advanced_collapse_opened3) {
          this._advanced_collapse3.toggle();
        }
        if (this.state._advanced_collapse_opened2) {
          this._advanced_collapse2.toggle();
        }
      } else {
        if (this.state._advanced_collapse_opened3) {
          this._advanced_collapse3.toggle();
        }
        if (
          !this.state._advanced_collapse_opened2 &&
          this._advanced_collapse2
        ) {
          this._advanced_collapse2.toggle();
        }
      }

      // if (newSelectedTags == 0 && this._anomaliesCount == 0) {
      //   this._advanced_collapse2.close();
      // }

      return {
        selectedTags: newSelectedTags,
        filteredData: newFilteredData,
      };
    });
  };

  getPartial(selectedTags, filteredData) {
    // let partial = "";

    // if (selectedTags.length > 0) {
    //   partial = `/${filteredData.length}`;
    // }
    return `/${filteredData.length}`;
  }

  getTagCounts = () => {
    const counter = {};
    this.state.filteredData.forEach((obj) => {
      const tags = obj.tags
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      [...new Set(tags)].forEach((tag) => {
        counter[tag] = (counter[tag] || 0) + 1;
      });
    });
    return counter;
  };

  getDisabledTags = () => {
    const { selectedTags, filteredData } = this.state;
    const disabled = {};

    if (selectedTags.length === 0) return disabled;

    const coexistingTags = new Set();
    filteredData.forEach((obj) => {
      const tags = obj.tags
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      tags.forEach((tag) => coexistingTags.add(tag));
    });

    this.state.countTag.forEach((tag) => {
      if (!selectedTags.includes(tag) && !coexistingTags.has(tag)) {
        disabled[tag] = true;
      }
    });

    return disabled;
  };

  formatAnomaliesData(data) {
    this.noTagCount = data.filter((item) => item.tags == "").length;

    this._anomaliesCount = data.filter((_C_online0) => {
      return (
        (_C_online0.color == "danger" && _C_online0.diag != "N") ||
        (_C_online0.diag == "N" && _C_online0.explicit_mac == "yes")
      );
    }).length;
    this._countProbAnomalies = data
      .filter((_C_online0) => {
        return (
          (_C_online0.color == "danger" && _C_online0.diag != "N") ||
          (_C_online0.diag == "N" && _C_online0.explicit_mac == "yes")
        );
      })
      .reduce((sums, entry) => {
        sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
        return sums;
      }, {});

    this._countEssidAnomalies = data
      .filter((_C_online0) => {
        return (
          (_C_online0.color == "danger" && _C_online0.diag != "N") ||
          (_C_online0.diag == "N" && _C_online0.explicit_mac == "yes")
        );
      })
      .reduce((sums, entry) => {
        sums[entry.essid] = (sums[entry.essid] || 0) + 1;
        return sums;
      }, {});

    this._countAPsAnomalies = data
      .filter((_C_online0) => {
        return _C_online0.color == "danger" && _C_online0.diag != "N";
      })
      .reduce((sums, entry) => {
        sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
        return sums;
      }, {});

    this._countLabelAnomalies = data
      .filter((_C_online0) => {
        return _C_online0.color == "danger" && _C_online0.diag != "N";
      })
      .reduce((sums, entry) => {
        sums[entry.label] = (sums[entry.label] || 0) + 1;
        return sums;
      }, {});

    this._countMeasureNameAnomalies = data
      .filter((_C_online0) => {
        return (
          (_C_online0.color == "danger" && _C_online0.diag != "N") ||
          (_C_online0.diag == "N" && _C_online0.explicit_mac == "yes")
        );
      })
      .reduce((sums, entry) => {
        sums[entry.name] = (sums[entry.name] || 0) + 1;
        return sums;
      }, {});

    // NOT ENOUGH COUNT

    this._notEnoughCount = data.filter((_C_online0) => {
      return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
    }).length;

    this._countProbNotEnough = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
      })
      .reduce((sums, entry) => {
        sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
        return sums;
      }, {});

    this._countEssidNotEnough = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
      })
      .reduce((sums, entry) => {
        sums[entry.essid] = (sums[entry.essid] || 0) + 1;
        return sums;
      }, {});

    this._countApsNotEnough = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
      })
      .reduce((sums, entry) => {
        sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
        return sums;
      }, {});

    this._countLabelNotEnough = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
      })
      .reduce((sums, entry) => {
        sums[entry.label] = (sums[entry.label] || 0) + 1;
        return sums;
      }, {});

    this._countMeasureNameNotEnough = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "yes";
      })
      .reduce((sums, entry) => {
        sums[entry.name] = (sums[entry.name] || 0) + 1;
        return sums;
      }, {});

    // NOT ENOUGH Gray COUNT

    this._notEnoughCount_gray = data.filter((_C_online0) => {
      return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
    }).length;

    this._countProbNotEnough_gray = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
      })
      .reduce((sums, entry) => {
        sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
        return sums;
      }, {});

    this._countEssidNotEnough_gray = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
      })
      .reduce((sums, entry) => {
        sums[entry.essid] = (sums[entry.essid] || 0) + 1;
        return sums;
      }, {});

    this._countApsNotEnough_gray = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
      })
      .reduce((sums, entry) => {
        sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
        return sums;
      }, {});

    this._countLabelNotEnough_gray = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
      })
      .reduce((sums, entry) => {
        sums[entry.label] = (sums[entry.label] || 0) + 1;
        return sums;
      }, {});

    this._countMeasureNameNotEnough_gray = data
      .filter((_C_online0) => {
        return _C_online0.diag == "N" && _C_online0.explicit_mac == "no";
      })
      .reduce((sums, entry) => {
        sums[entry.name] = (sums[entry.name] || 0) + 1;
        return sums;
      }, {});

    // WORKING COUNT

    this._workingCount = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    }).length;
    this._countProbWorking = data
      .filter((_C_online0) => {
        return _C_online0.color == "success";
      })
      .reduce((sums, entry) => {
        sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
        return sums;
      }, {});

    this._countEssidWorking = data
      .filter((_C_online0) => {
        return _C_online0.color == "success";
      })
      .reduce((sums, entry) => {
        sums[entry.essid] = (sums[entry.essid] || 0) + 1;
        return sums;
      }, {});

    this._countAPsWorking = data
      .filter((_C_online0) => {
        return _C_online0.color == "success";
      })
      .reduce((sums, entry) => {
        sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
        return sums;
      }, {});
    this._countLabelWorking = data
      .filter((_C_online0) => {
        return _C_online0.color == "success";
      })
      .reduce((sums, entry) => {
        sums[entry.label] = (sums[entry.label] || 0) + 1;
        return sums;
      }, {});

    this._countMeasureNameWorking = data
      .filter((_C_online0) => {
        return _C_online0.color == "success";
      })
      .reduce((sums, entry) => {
        sums[entry.name] = (sums[entry.name] || 0) + 1;
        return sums;
      }, {});
  }

  parseStringToArray(str) {
    return str
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item !== "");
  }

  saveTagList(data) {
    let tagList = [];

    for (const elem of data) {
      let arrayOfTags = this.parseStringToArray(elem.tags);
      arrayOfTags.forEach((t) => {
        if (!tagList.includes(t)) {
          tagList.push(t);
        }
      });
    }

    return tagList.sort((a, b) =>
      a.localeCompare(b, "it", { sensitivity: "base" }),
    );
  }

  tagCount(array) {
    const tagCounter = {};

    array.forEach((obj) => {
      if (obj.tags) {
        // Dividi per virgola, rimuovi spazi e filtra gli elementi vuoti
        const tags = obj.tags
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean);

        tags.forEach((tag) => {
          tagCounter[tag] = (tagCounter[tag] || 0) + 1;
        });
      }
    });

    return tagCounter;
  }

  getAllTags(data) {
    const allTagsSet = new Set();
    data.forEach((obj) => {
      const tags = obj.tags
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
      tags.forEach((tag) => allTagsSet.add(tag));
    });
    return Array.from(allTagsSet);
  }

  loadDiag(refresh) {
    let selectedTags = [];
    if (
      this.getAppContext().getLocalStorageService().get("goBackTags") &&
      this.getAppContext().getLocalStorageService().get("goBackTags")
        .selectedTags
    ) {
      selectedTags = this.getAppContext()
        .getLocalStorageService()
        .get("goBackTags").selectedTags;
    }
    console.log("selectedTags", selectedTags);
    this.setState(
      {
        loading: true,
        countTag: [],
        selectedTags,
        filteredDataTags: [],
        // searchKey: "",
      },
      () => {
        this.apiStore.fire("dashboard_diag", {
          ___onSuccess: (_, data) => {
            if (this.mounted) {
              this.getAppContext()
                .getLocalStorageService()
                .remove("goBackTags");
              let countTag = {};
              if (data.online) {
                const tagCounts = this.getTagCounts(data.online);
                this.orderedTags = Object.entries(tagCounts)
                  .sort((a, b) => {
                    const countDiff = b[1] - a[1];
                    return countDiff !== 0
                      ? countDiff
                      : a[0].localeCompare(b[0]);
                  })
                  .map(([tag]) => tag);
                countTag = this.getAllTags(data.online);
                this.formatAnomaliesData(
                  data.online.filter((item) => {
                    const itemTags = item.tags
                      .split(",")
                      .map((t) => t.trim())
                      .filter(Boolean);
                    return this.state.selectedTags.every((selectedTag) =>
                      itemTags.includes(selectedTag),
                    );
                  }),
                );
              }
              this.props.disableLoading();
              this.setState(
                {
                  data,
                  loading: false,
                  countTag,
                  filteredData: data.online.filter((item) => {
                    const itemTags = item.tags
                      .split(",")
                      .map((t) => t.trim())
                      .filter(Boolean);

                    return this.state.selectedTags.every((selectedTag) =>
                      itemTags.includes(selectedTag),
                    );
                  }),
                  filteredDataTags: data.online.filter((item) => {
                    const itemTags = item.tags
                      .split(",")
                      .map((t) => t.trim())
                      .filter(Boolean);
                    return this.state.selectedTags.every((selectedTag) =>
                      itemTags.includes(selectedTag),
                    );
                  }),
                },
                () => {
                  if (refresh) {
                    this._autorefresh = setInterval(() => {
                      this.loadDiag();
                    }, 120000);
                  }
                },
              );
            }
          },
        });
      },
    );
  }

  renderInlineTags(string, selectedTags) {
    let arrayOfTags = this.parseStringToArray(string);

    return (
      <div className="">
        {arrayOfTags
          .sort((a, b) =>
            a.localeCompare(b, "it", {
              sensitivity: "base",
            }),
          )
          .map((tag) => {
            const isSelected = selectedTags.includes(tag);

            return (
              <Badge
                key={tag}
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  // color: "#a1a9b0",
                  fontWeight: isSelected ? "600" : "400",
                }}
                pill
                onClick={() => this.handleTagClick(tag)}
                className={`border mr-2 mb-1 bg-white ${
                  isSelected
                    ? "border-2 border-gray700 text-gray800 "
                    : "border-muted text-gray700 "
                }`}
              >
                {tag}
              </Badge>
            );
          })}
      </div>
    );
  }

  makeInfoText(diff) {
    if (diff < 3600) {
      const min = diff / 60;
      return this.generateText({
        value: min,
        time: "minutes",
        color: "muted",
      });
    }
    if (diff >= 3600 && diff < 86400) {
      const hours = diff / 3600;
      return this.generateText({
        value: hours,
        time: "hours",
        color: "danger",
      });
    }
    if (diff >= 86400) {
      const days = diff / 86400;
      return this.generateText({
        value: days,
        time: "days",
        color: "danger",
      });
    }
  }

  generateText({ value, time, color }) {
    return (
      <div className={`text-${color} py-3`}>
        <strong>{`The current diagnostics may differ from those mentioned in the email you received over ${parseInt(
          value,
        )} ${time} ago.`}</strong>
      </div>
    );
  }

  onComponentWillUnmount() {
    this.mounted = false;
    this.setState({ loading: true });
    clearInterval(this._autorefresh);
    if (this.getAppContext().getLocalStorageService().get("goBackTags")) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
    }
  }

  getMlist(measures) {
    let mlist = {};
    measures.forEach(({ probeid, cssid }) => {
      if (mlist[probeid]) {
        mlist[probeid].push(cssid);
      } else {
        mlist[probeid] = [cssid];
      }
    });
    return mlist;
  }

  onRender() {
    const tagCounts = this.getTagCounts();
    const disabledTags = this.getDisabledTags(tagCounts);
    const tests = this.state.filteredData.reduce(
      (acc, cur) => (acc.includes(cur.test) ? acc : [...acc, cur.test]),
      [],
    );
    const dataLength = this.state.filteredData.length;
    const mlist = this.getMlist(this.state.filteredData);
    const search = this.state.countTag.filter((elem) =>
      elem.toLowerCase().includes(this.props.searchKey.toLowerCase()),
    );
    return (
      <Section designType="narrow">
        <_LoadingWrapper
          loadingPlug={this.state.loading}
          hideOnLoading={true}
          minHeight
        >
          {this.state.infoText && this.state.infoText}
          {this.state.showTags && (
            <div>
              {/* <Row>
                <Col xl={2} className="ml-auto">
                  <Input
                    type="text"
                    className="form-input-text"
                    placeholder="Tags search"
                    bsSize="md"
                    disabled={this.state.loading}
                    onChange={(e) => {
                      this.setState({ searchKey: e.target.value });
                    }}
                  />
                </Col>
              </Row> */}
              <div className="mb-1">
                <div className="mb-2 mt-3">
                  {this.state.countTag
                    .sort((a, b) => {
                      const aSelected = this.state.selectedTags.includes(a);
                      const bSelected = this.state.selectedTags.includes(b);

                      if (aSelected && !bSelected) return -1;
                      if (!aSelected && bSelected) return 1;

                      const countDiff =
                        (tagCounts[b] || 0) - (tagCounts[a] || 0);
                      if (countDiff !== 0) return countDiff;

                      return a.localeCompare(b);
                    })
                    .filter((tag) => !disabledTags[tag])
                    .map((tag) => {
                      const count = tagCounts[tag] || 0;
                      const isSelected = this.state.selectedTags.includes(tag);
                      let background = "bg-white border-gray700 text-gray700 ";
                      if (this.props.searchKey && search.includes(tag)) {
                        background = "selected-bg border-primary text-primary ";
                      }
                      return (
                        <Badge
                          key={tag}
                          style={{
                            fontSize: "16px",
                            cursor: this.state.loading ? "unset" : "pointer",
                            fontWeight: isSelected ? "700" : "400",
                          }}
                          pill
                          className={`border ${background} mr-2 my-1 ${
                            isSelected ? "border-3 text-gray800 " : ""
                          }`}
                          onClick={() => {
                            if (!this.state.loading) {
                              this.handleTagClick(tag);
                            }
                          }}
                        >
                          {tag}{" "}
                          <span style={{ fontWeight: "400" }}>({count})</span>
                        </Badge>
                      );
                    })}
                </div>
                <div className="mb-2">
                  {this.state.countTag
                    .sort((a, b) => {
                      const countDiff =
                        (tagCounts[b] || 0) - (tagCounts[a] || 0);
                      return countDiff !== 0 ? countDiff : a.localeCompare(b);
                    })
                    .filter((tag) => disabledTags[tag])
                    .map((tag) => {
                      const count = tagCounts[tag] || 0;
                      let background = "bg-white ";
                      if (this.props.searchKey && search.includes(tag)) {
                        background = "selected-bg-secondary";
                      }
                      return (
                        <Badge
                          key={tag}
                          style={{
                            fontSize: "16px",
                            cursor: "",
                            color: "#949ca3ff",
                            fontWeight: "400",
                          }}
                          pill
                          className={`border mr-2 my-1 ${background} border-muted`}
                        >
                          {tag}{" "}
                          <span style={{ fontWeight: "400" }}>({count})</span>
                        </Badge>
                      );
                    })}
                </div>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-between flex-grow-1 pt-3">
            <div className="text-gray600">
              {this.state.selectedTags && this.state.selectedTags.length > 0 ? (
                tests.length != 1 ? (
                  <strong className="mr-2">
                    These measures are heterogeneous, cannot aggregate them for
                    overall chart
                  </strong>
                ) : dataLength > 1 ? (
                  <Link
                    to={{
                      pathname: "/active/aggregate",
                      state: { mlist, selectedTags: this.state.selectedTags },
                    }}
                  >
                    <strong
                      style={{ cursor: "pointer" }}
                      className="mr-2 text-primary link-color"
                    >
                      These measures are homogeneous, click here to generate
                      aggregate chart
                    </strong>
                  </Link>
                ) : null
              ) : null}
            </div>
            <ReactOForm
              onControllerReady={(form_controller) => {
                this._reload_form = form_controller;
              }}
              onFormDataChange={(new_data) => {
                if (new_data.autorefresh == "on") {
                  setTimeout(() => {
                    this.loadDiag(true);
                  }, 120000);
                } else if (new_data.autorefresh == "off") {
                  clearInterval(this._autorefresh);
                }
              }}
            >
              <strong
                className="sub-title mr-2"
                style={{ display: "inline-block" }}
              >
                Autorefresh every 2 minutes
              </strong>
              <div style={{ display: "inline-block" }}>
                <ReactOFormInput type="switch" data_key="autorefresh" />
              </div>
            </ReactOForm>
          </div>
          <div>
            {this._countProbAnomalies ? (
              <div className="mb-1">
                {this._anomaliesCount > 0 && (
                  <Panel bodyClassName="p-0" rounded>
                    <div
                      className={
                        this._anomaliesCount > 0
                          ? "diag-bg"
                          : "diag-bg_nocursor"
                      }
                      onClick={() => {
                        if (this._anomaliesCount > 0) {
                          this._advanced_collapse2.toggle();
                        }
                      }}
                    >
                      <div className="py-3">
                        <Col xs={12}>
                          <Row
                            noGutters
                            style={
                              this.getAppContext().media.isMobile
                                ? { display: "block" }
                                : null
                            }
                          >
                            <div
                              className={
                                this.getAppContext().media.isMobile
                                  ? "mb-2"
                                  : "flex-grow-1"
                              }
                            >
                              <h5 className="pt-2">
                                {`${
                                  this._anomaliesCount +
                                  (this.state.selectedTags.length > 0
                                    ? this._notEnoughCount
                                    : 0)
                                }${this.getPartial(
                                  this.state.selectedTags,
                                  this.state.filteredData,
                                )} measure${
                                  this._anomaliesCount == 1 ? "" : "s"
                                } with anomalies`}
                              </h5>
                            </div>
                            {this.getAppContext().media.isMobile ? (
                              <div className="d-flex flex-grow-1">
                                <div className="pt-1 flex-grow-1">
                                  <strong>
                                    {Object.keys(this._countProbAnomalies)
                                      .length + " PROBE "}
                                    {this.getAppContext().platformName() ==
                                    "WiFiProbe"
                                      ? Object.keys(this._countEssidAnomalies)
                                          .length + " ESSID "
                                      : Object.keys(
                                          this._countMeasureNameAnomalies,
                                        ).length + " MEASURE "}
                                    {/* {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? this._countAPsAnomalies["-"]
                                      ? this._countAPsAnomalies["-"] +
                                        Object.keys(this._countAPsAnomalies)
                                          .length -
                                        1 +
                                        " AP "
                                      : Object.keys(this._countAPsAnomalies)
                                          .length + " AP"
                                    : Object.keys(this._countLabelAnomalies)
                                        .length + " LABEL "} */}
                                  </strong>
                                </div>
                                <div className="pt-2 justify-content-end">
                                  <span
                                    className={
                                      this.state._advanced_collapse_opened2 ==
                                      false
                                        ? "icon-caret-down-outline"
                                        : "icon-caret-up-outline"
                                    }
                                  ></span>
                                </div>
                              </div>
                            ) : (
                              <div className="pt-2 justify-content-end">
                                <strong>
                                  {
                                    "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                  }
                                  {Object.keys(this._countProbAnomalies)
                                    .length +
                                    (this.state.selectedTags.length > 0
                                      ? Object.keys(this._countProbNotEnough)
                                          .length
                                      : 0) +
                                    " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                  {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? Object.keys(this._countEssidAnomalies)
                                        .length +
                                      (this.state.selectedTags.length > 0
                                        ? Object.keys(this._countEssidNotEnough)
                                            .length
                                        : 0) +
                                      " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                    : Object.keys(
                                        this._countMeasureNameAnomalies,
                                      ).length +
                                      " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {this._anomaliesCount != "0" && (
                                    <>
                                      Details
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened2 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </>
                                  )}
                                </strong>
                              </div>
                            )}
                          </Row>
                        </Col>
                      </div>
                    </div>

                    <ReactOCollapse
                      className="border-top border-2 border-danger"
                      onControllerReady={(_collapse_controller) => {
                        this._advanced_collapse2 = _collapse_controller;
                        this.setState({
                          _advanced_collapse_opened2: false,
                        });
                      }}
                      onOpened={() => {
                        this.setState({ _advanced_collapse_opened2: true });
                      }}
                      onClosed={() => {
                        this.setState({
                          _advanced_collapse_opened2: false,
                        });
                      }}
                      initOpen={this._anomaliesCount > 0}
                      // initOpen={true}
                    >
                      {this.state.filteredData && (
                        <div>
                          <ReactOTable
                            thClassName="px-3 py-1"
                            tdClassName="align-middle px-3 py-2"
                            hoverable
                            compressedDark
                            compressed={this.getAppContext().media.isMobile}
                            thDividers
                            cols={[
                              {
                                title: "PROBE",
                                align: "center",
                                data_key: "probe",
                                width: "15",
                                sortable: true,
                              },
                              {
                                title: "MEASURE",
                                align: "center",
                                data_key: "measure",
                                width: "20",
                                sortable: true,
                              },
                              {
                                title: "TAGS",
                                align: "center",
                                data_key: "tags",
                                width: "30",
                                sortable: false,
                              },
                              {
                                title: "STATUS",
                                align: "center",
                                data_key: "status",
                                width: "15",
                                sortable: false,
                              },
                              {
                                title: "SINCE",
                                align: "center",
                                data_key: "since",
                                width: "15",
                                sortable: true,
                              },
                            ]}
                            rows={(() => {
                              let data = [];

                              this.state.filteredData
                                .filter((d) => this.filterDataAnomalies(d))
                                .forEach((d, id) => {
                                  data.push({
                                    probe: {
                                      value: d.probeid,
                                      render: (
                                        <div
                                          onClick={() => {
                                            this.getAppContext()
                                              .getLocalStorageService()
                                              .set(
                                                "goBackExplorer",
                                                "/dashboard?tab=smart",
                                              );
                                          }}
                                        >
                                          <Link
                                            to={{
                                              pathname:
                                                "/" +
                                                d.probeid +
                                                "/active/" +
                                                d.cssid +
                                                "/" +
                                                (d.bssid != "-"
                                                  ? d.bssid.replace(/:/g, "")
                                                  : "overal"),
                                              state: {
                                                mlist,
                                                selectedTags:
                                                  this.state.selectedTags,
                                              },
                                            }}
                                          >
                                            <strong> {d.probename} </strong>
                                            <div className="sub-title">
                                              {d.probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}
                                            </div>
                                          </Link>
                                        </div>
                                      ),
                                    },
                                    measure: {
                                      value: d.name,
                                      render: (
                                        <div
                                          onClick={() => {
                                            this.getAppContext()
                                              .getLocalStorageService()
                                              .set(
                                                "goBackExplorer",
                                                "/dashboard?tab=smart",
                                              );
                                          }}
                                        >
                                          <Link
                                            to={{
                                              pathname:
                                                "/" +
                                                d.probeid +
                                                "/active/" +
                                                d.cssid +
                                                "/" +
                                                (d.bssid != "-"
                                                  ? d.bssid.replace(/:/g, "")
                                                  : "overal"),
                                              state: {
                                                mlist,
                                                selectedTags:
                                                  this.state.selectedTags,
                                              },
                                            }}
                                          >
                                            <strong>{d.name}</strong>
                                          </Link>
                                        </div>
                                      ),
                                    },
                                    tags: {
                                      value: d.tags,
                                      render: this.renderInlineTags(
                                        d.tags,
                                        this.state.selectedTags,
                                      ),
                                    },
                                    status: {
                                      value: d.status,
                                      render: (
                                        <div
                                          onClick={() => {
                                            this.getAppContext()
                                              .getLocalStorageService()
                                              .set(
                                                "goBackExplorer",
                                                "/dashboard?tab=smart",
                                              );
                                          }}
                                        >
                                          <Link
                                            to={{
                                              pathname:
                                                "/" +
                                                d.probeid +
                                                "/active/" +
                                                d.cssid +
                                                "/" +
                                                (d.bssid != "-"
                                                  ? d.bssid.replace(/:/g, "")
                                                  : "overal"),
                                              state: {
                                                mlist,
                                                selectedTags:
                                                  this.state.selectedTags,
                                              },
                                            }}
                                          >
                                            <span
                                              className={
                                                d.last_state == "N" ||
                                                d.last_state == "U"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      d.last_state
                                                    ].color
                                                  : "text-" + d.color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[d.diag]
                                                  .text
                                              }
                                            </span>
                                            {d.err_step ? (
                                              <div
                                                className={
                                                  d.last_state == "N" ||
                                                  d.last_state == "U"
                                                    ? "sub-title text-" +
                                                      this.getAppContext().conf
                                                        .MLY_STATES_DICTIONARY[
                                                        d.last_state
                                                      ].color
                                                    : "sub-title text-" +
                                                      d.color
                                                }
                                              >
                                                {d.err_step &&
                                                d.err_step.length > 0
                                                  ? d.err_step.substring(
                                                      0,
                                                      2,
                                                    ) == "MO"
                                                    ? "mostly on " +
                                                      d.err_step.substring(
                                                        3,
                                                        d.err_step.length,
                                                      )
                                                    : "on " +
                                                      d.err_step.substring(
                                                        3,
                                                        d.err_step.length,
                                                      )
                                                  : null}
                                              </div>
                                            ) : null}
                                          </Link>
                                        </div>
                                      ),
                                    },
                                    since: {
                                      value: d.since,
                                      render: (
                                        <div
                                          onClick={() => {
                                            this.getAppContext()
                                              .getLocalStorageService()
                                              .set(
                                                "goBackExplorer",
                                                "/dashboard?tab=smart",
                                              );
                                          }}
                                        >
                                          <Link
                                            to={{
                                              pathname:
                                                "/" +
                                                d.probeid +
                                                "/active/" +
                                                d.cssid +
                                                "/" +
                                                (d.bssid != "-"
                                                  ? d.bssid.replace(/:/g, "")
                                                  : "overal"),
                                              state: {
                                                mlist,
                                                selectedTags:
                                                  this.state.selectedTags,
                                              },
                                            }}
                                          >
                                            {this.getAppContext()
                                              .momentjs(d.since, "X")
                                              .format("YYYY") < 2014 ? (
                                              "-"
                                            ) : (
                                              <div>
                                                <div>
                                                  {this.getAppContext()
                                                    .momentjs(d.since, "X")
                                                    .format("DD-MM-YYYY")}
                                                </div>
                                                <div className="sub-title">
                                                  {this.getAppContext()
                                                    .momentjs(d.since, "X")
                                                    .format("HH:mm")}
                                                </div>
                                              </div>
                                            )}
                                          </Link>
                                        </div>
                                      ),
                                    },
                                  });
                                });
                              return data;
                            })()}
                          ></ReactOTable>
                        </div>
                      )}
                    </ReactOCollapse>
                  </Panel>
                )}
              </div>
            ) : null}

            {this.state?.selectedTags?.length == 0 && (
              <>
                {this.state?.data?.offline.length > 0 ? (
                  <div className="mt-2">
                    <Panel className="mt-0" bodyClassName="p-0" rounded>
                      <div
                        className="diag-bg"
                        onClick={() => {
                          this._advanced_collapse_off.toggle();
                        }}
                      >
                        <div className="py-3">
                          <Col xs={12}>
                            <Row
                              noGutters
                              style={
                                this.getAppContext().media.isMobile
                                  ? { display: "block" }
                                  : null
                              }
                            >
                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <h5 className="pt-2">
                                    {this.state.data.zzz_offline == 1
                                      ? this.state.data.zzz_offline +
                                        " probe offline"
                                      : this.state.data.zzz_offline +
                                        " probes offline"}
                                  </h5>
                                </div>

                                <div className="pt-2 justify-content-end">
                                  <strong>
                                    {this.getAppContext().media.isMobile
                                      ? null
                                      : "Details "}
                                    <span
                                      className={
                                        this.state
                                          ._advanced_collapse_opened_off ==
                                        false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              </div>
                            </Row>
                          </Col>
                        </div>
                      </div>

                      <ReactOCollapse
                        className="border-top border-2 border-danger"
                        onControllerReady={(_collapse_controller) => {
                          this._advanced_collapse_off = _collapse_controller;
                          this.setState({
                            _advanced_collapse_opened1: false,
                          });
                        }}
                        onOpened={() => {
                          this.setState({
                            _advanced_collapse_opened_off: true,
                          });
                        }}
                        onClosed={() => {
                          this.setState({
                            _advanced_collapse_opened_off: false,
                          });
                        }}
                        initOpen={false}
                        // initOpen={this.checkOpen("3")}
                      >
                        <ReactOTable
                          thClassName="px-3 py-1"
                          tdClassName="align-middle px-3 py-2"
                          hoverable
                          onRowClick={
                            this.props.onItemClick
                              ? this.props.onItemClick
                              : (row_data) => {
                                  // console.log(row_data);
                                }
                          }
                          compressed={
                            this.getAppContext().media.isMobile ||
                            this.getAppContext().media.isTablet
                          }
                          compressedRowRendering={(row_items, link) => {
                            return link ? (
                              <div>
                                <Link
                                  className="link-table-test"
                                  to={link}
                                  target="_blank"
                                >
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.probe.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.probe.content}
                                  </div>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.status.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.status.content}
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.since.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.since.content}
                                </Link>
                              </div>
                            ) : (
                              <div>
                                <div className="mt-2">
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.probe.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.probe.content}
                                </div>
                                <div className="text-muted">
                                  <small className="">
                                    <strong>{row_items.status.title}</strong>
                                  </small>
                                </div>
                                {row_items.status.content}
                                <div className="text-muted">
                                  <small className="">
                                    <strong>{row_items.since.title}</strong>
                                  </small>
                                </div>
                                {row_items.since.content}
                              </div>
                            );
                          }}
                          thDividers
                          defaultSort={[
                            {
                              data_key: "since",
                              order: "asc",
                            },
                            {
                              data_key: "probe",
                              order: "asc",
                            },
                            {
                              data_key: "status",
                              order: "asc",
                            },
                          ]}
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "30",
                              sortable: true,
                            },
                            {
                              title: "STATUS",
                              align: "center",
                              data_key: "status",
                              width: "30",
                              sortable: false,
                            },
                            {
                              title: "SINCE",
                              align: "center",
                              data_key: "since",
                              width: "30",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let _TMP1 = [];
                            this.state.data.offline.forEach((_C_row, C_id) => {
                              _TMP1.push({
                                _link: "/" + _C_row.probeid + "/active/",
                                _title: `View active measures for ${_C_row.name}`,
                                probe: {
                                  value: _C_row.name,
                                  info: _C_row.probeid,
                                  render: (
                                    <div>
                                      <div>
                                        <strong> {_C_row.name} </strong>{" "}
                                      </div>
                                      <span className="sub-title">
                                        {" "}
                                        {_C_row.mac}{" "}
                                      </span>
                                    </div>
                                  ),
                                },
                                status: {
                                  value: "offline",
                                  render: (
                                    <div>
                                      <span className="text-danger">
                                        Offline
                                      </span>
                                      {_C_row.step ? (
                                        <div className="sub-title text-danger">
                                          {_C_row.step}
                                        </div>
                                      ) : null}
                                    </div>
                                  ),
                                },
                                since: {
                                  value: _C_row.since,
                                  render: (
                                    <div>
                                      {this.getAppContext()
                                        .momentjs(_C_row.since, "X")
                                        .format("YYYY") < 2014 ? (
                                        "-"
                                      ) : (
                                        <div>
                                          <div>
                                            {this.getAppContext()
                                              .momentjs(_C_row.since, "X")
                                              .format("DD-MM-YYYY")}
                                          </div>
                                          <div className="sub-title">
                                            {this.getAppContext()
                                              .momentjs(_C_row.since, "X")
                                              .format("HH:mm")}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ), // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                                },
                              });
                            });
                            return _TMP1;
                          })()}
                        ></ReactOTable>
                      </ReactOCollapse>
                    </Panel>
                  </div>
                ) : (
                  <div className="mt-2">
                    <Panel bodyClassName="p-3" rounded>
                      <h5>All probes are online</h5>
                    </Panel>
                  </div>
                )}
              </>
            )}
            {this._countProbWorking && this._countProbWorking && (
              <Panel className="mt-2" bodyClassName="p-0" rounded>
                <div
                  className="working-bg"
                  onClick={
                    this._workingCount != 0
                      ? () => {
                          this._advanced_collapse3.toggle();
                        }
                      : null
                  }
                >
                  <div className="py-3">
                    <Col xs={12}>
                      <Row
                        noGutters
                        style={
                          this.getAppContext().media.isMobile
                            ? { display: "block" }
                            : null
                        }
                      >
                        <div
                          className={
                            this.getAppContext().media.isMobile
                              ? "mb-2"
                              : "flex-grow-1"
                          }
                        >
                          <h5 className="pt-2">
                            {`${this._workingCount}${this.getPartial(
                              this.state.selectedTags,
                              this.state.filteredData,
                            )} working measure${
                              this._workingCount == 1 ? "" : "s"
                            }`}
                          </h5>
                        </div>
                        {this._workingCount != 0 ? (
                          this.getAppContext().media.isMobile ? (
                            <div className="d-flex flex-grow-1">
                              <div className="pt-1 flex-grow-1">
                                <strong>
                                  {Object.keys(this._countProbWorking).length +
                                    " PROBE "}
                                  {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? Object.keys(this._countEssidWorking)
                                        .length + " ESSID "
                                    : Object.keys(this._countMeasureNameWorking)
                                        .length + " MEASURE "}

                                  {this._countAPsWorking["-"]
                                    ? Object.keys(this._countAPsWorking)
                                        .length + " AP "
                                    : Object.keys(this._countAPsWorking)
                                        .length + " AP "}
                                </strong>
                              </div>
                              <div className="pt-2 justify-content-end">
                                <span
                                  className={
                                    this.state._advanced_collapse_opened3 ==
                                    false
                                      ? "icon-caret-down-outline"
                                      : "icon-caret-up-outline"
                                  }
                                ></span>
                              </div>
                            </div>
                          ) : (
                            <div className="pt-2">
                              <strong>
                                {
                                  "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                }
                                {Object.keys(this._countProbWorking).length +
                                  " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                {this.getAppContext().platformName() ==
                                "WiFiProbe"
                                  ? Object.keys(this._countEssidWorking)
                                      .length +
                                    " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                  : Object.keys(this._countMeasureNameWorking)
                                      .length +
                                    " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                {this.getAppContext().platformName() ==
                                "WiFiProbe"
                                  ? this._countAPsWorking["-"]
                                    ? Object.keys(this._countAPsWorking)
                                        .length + " AP "
                                    : Object.keys(this._countAPsWorking)
                                        .length + " AP"
                                  : null}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}Details
                                <span
                                  className={
                                    this.state._advanced_collapse_opened3 ==
                                    false
                                      ? "icon-caret-down-outline"
                                      : "icon-caret-up-outline"
                                  }
                                ></span>
                              </strong>
                            </div>
                          )
                        ) : null}
                      </Row>
                    </Col>
                  </div>
                </div>
                <ReactOCollapse
                  className="border-top border-2 border-success"
                  onControllerReady={(_collapse_controller) => {
                    this._advanced_collapse3 = _collapse_controller;
                    this.setState({
                      _advanced_collapse_opened3: false,
                    });
                  }}
                  onOpened={() => {
                    this.setState({ _advanced_collapse_opened3: true });
                  }}
                  onClosed={() => {
                    this.setState({
                      _advanced_collapse_opened3: false,
                    });
                  }}
                  initOpen={this.state.selectedTags?.length > 0 || false}
                >
                  {this.state.filteredData && (
                    <div>
                      <ReactOTable
                        thClassName="px-3 py-1"
                        tdClassName="align-middle px-3 py-2"
                        hoverable
                        compressedDark
                        compressed={this.getAppContext().media.isMobile}
                        thDividers
                        cols={[
                          {
                            title: "PROBE",
                            align: "center",
                            data_key: "probe",
                            width: "15",
                            sortable: true,
                          },
                          {
                            title: "MEASURE",
                            align: "center",
                            data_key: "measure",
                            width: "20",
                            sortable: true,
                          },
                          {
                            title: "TAGS",
                            align: "center",
                            data_key: "tags",
                            width: "30",
                            sortable: false,
                          },
                          {
                            title: "STATUS",
                            align: "center",
                            data_key: "status",
                            width: "15",
                            sortable: false,
                          },
                          {
                            title: "SINCE",
                            align: "center",
                            data_key: "since",
                            width: "15",
                            sortable: true,
                          },
                        ]}
                        rows={(() => {
                          let data = [];

                          this.state.filteredData
                            .filter((d) => d.color == "success")
                            .forEach((d, id) => {
                              data.push({
                                probe: {
                                  value: d.probeid,
                                  render: (
                                    <div
                                      onClick={() => {
                                        this.getAppContext()
                                          .getLocalStorageService()
                                          .set(
                                            "goBackExplorer",
                                            "/dashboard?tab=smart",
                                          );
                                      }}
                                    >
                                      <Link
                                        to={{
                                          pathname:
                                            "/" +
                                            d.probeid +
                                            "/active/" +
                                            d.cssid +
                                            "/" +
                                            (d.bssid != "-"
                                              ? d.bssid.replace(/:/g, "")
                                              : "overal"),
                                          state: {
                                            mlist,
                                            selectedTags:
                                              this.state.selectedTags,
                                          },
                                        }}
                                      >
                                        <strong> {d.probename} </strong>
                                        <div className="sub-title">
                                          {d.probeid
                                            .replace(/(..)/g, "$1:")
                                            .slice(0, -1)}
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                measure: {
                                  value: d.name,
                                  render: (
                                    <div
                                      onClick={() => {
                                        this.getAppContext()
                                          .getLocalStorageService()
                                          .set(
                                            "goBackExplorer",
                                            "/dashboard?tab=smart",
                                          );
                                      }}
                                    >
                                      <Link
                                        to={{
                                          pathname:
                                            "/" +
                                            d.probeid +
                                            "/active/" +
                                            d.cssid +
                                            "/" +
                                            (d.bssid != "-"
                                              ? d.bssid.replace(/:/g, "")
                                              : "overal"),
                                          state: {
                                            mlist,
                                            selectedTags:
                                              this.state.selectedTags,
                                          },
                                        }}
                                      >
                                        <strong>{d.name}</strong>
                                        <div className="sub-title">
                                          TEST: <strong>{d.test}</strong>
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                tags: {
                                  value: d.tags,
                                  render: this.renderInlineTags(
                                    d.tags,
                                    this.state.selectedTags,
                                  ),
                                },
                                status: {
                                  value: d.status,
                                  render: (
                                    <div
                                      onClick={() => {
                                        this.getAppContext()
                                          .getLocalStorageService()
                                          .set(
                                            "goBackExplorer",
                                            "/dashboard?tab=smart",
                                          );
                                      }}
                                    >
                                      <Link
                                        to={{
                                          pathname:
                                            "/" +
                                            d.probeid +
                                            "/active/" +
                                            d.cssid +
                                            "/" +
                                            (d.bssid != "-"
                                              ? d.bssid.replace(/:/g, "")
                                              : "overal"),
                                          state: {
                                            mlist,
                                            selectedTags:
                                              this.state.selectedTags,
                                          },
                                        }}
                                      >
                                        <div>
                                          <span
                                            className={
                                              d.last_state == "N" ||
                                              d.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    d.last_state
                                                  ].color
                                                : "text-" + d.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[d.diag]
                                                .text
                                            }
                                          </span>
                                          {d.err_step ? (
                                            <div
                                              className={
                                                d.last_state == "N" ||
                                                d.last_state == "U"
                                                  ? "sub-title text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      d.last_state
                                                    ].color
                                                  : "sub-title text-" + d.color
                                              }
                                            >
                                              {d.err_step &&
                                              d.err_step.length > 0
                                                ? d.err_step.substring(0, 2) ==
                                                  "MO"
                                                  ? "mostly on " +
                                                    d.err_step.substring(
                                                      3,
                                                      d.err_step.length,
                                                    )
                                                  : "on " +
                                                    d.err_step.substring(
                                                      3,
                                                      d.err_step.length,
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                since: {
                                  value: d.since,
                                  render: (
                                    <div>
                                      <Link
                                        to={{
                                          pathname:
                                            "/" +
                                            d.probeid +
                                            "/active/" +
                                            d.cssid +
                                            "/" +
                                            (d.bssid != "-"
                                              ? d.bssid.replace(/:/g, "")
                                              : "overal"),
                                          state: {
                                            mlist,
                                            selectedTags:
                                              this.state.selectedTags,
                                          },
                                        }}
                                      >
                                        {this.getAppContext()
                                          .momentjs(d.since, "X")
                                          .format("YYYY") < 2014 ? (
                                          "-"
                                        ) : (
                                          <div>
                                            <div>
                                              {this.getAppContext()
                                                .momentjs(d.since, "X")
                                                .format("DD-MM-YYYY")}
                                            </div>
                                            <div className="sub-title">
                                              {this.getAppContext()
                                                .momentjs(d.since, "X")
                                                .format("HH:mm")}
                                            </div>
                                          </div>
                                        )}
                                      </Link>
                                    </div>
                                  ),
                                },
                              });
                            });
                          return data;
                        })()}
                      ></ReactOTable>
                    </div>
                  )}
                </ReactOCollapse>
              </Panel>
            )}

            {/* NOT ENOUGH WITHOUT EXPLICIT */}
            {this._countProbNotEnough_gray && this._notEnoughCount_gray > 0 ? (
              <div className="mb-1 mt-2">
                <Panel bodyClassName="p-0" rounded>
                  <div
                    className={"bg-light"}
                    onClick={() => {
                      if (this._notEnoughCount_gray > 0) {
                        this._advanced_collapse_ne.toggle();
                      }
                    }}
                  >
                    <div className="py-3">
                      <Col xs={12}>
                        <Row
                          noGutters
                          style={
                            this.getAppContext().media.isMobile
                              ? { display: "block" }
                              : null
                          }
                        >
                          <div
                            className={
                              this.getAppContext().media.isMobile
                                ? "mb-2"
                                : "flex-grow-1"
                            }
                          >
                            <h5 className="pt-2">
                              {`${this._notEnoughCount_gray}${this.getPartial(
                                this.state.selectedTags,
                                this.state.filteredData,
                              )} measures with not enough data`}
                            </h5>
                          </div>
                          {this.getAppContext().media.isMobile ? (
                            <div className="d-flex flex-grow-1">
                              <div className="pt-1 flex-grow-1">
                                <strong>
                                  {Object.keys(this._countProbNotEnough_gray)
                                    .length + " PROBE "}
                                  {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? Object.keys(
                                        this._countEssidNotEnough_gray,
                                      ).length + " ESSID "
                                    : Object.keys(
                                        this._countMeasureNameNotEnough_gray,
                                      ).length + " MEASURE "}
                                  {/* {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? this._countAPsAnomalies["-"]
                                      ? this._countAPsAnomalies["-"] +
                                        Object.keys(this._countAPsAnomalies)
                                          .length -
                                        1 +
                                        " AP "
                                      : Object.keys(this._countAPsAnomalies)
                                          .length + " AP"
                                    : Object.keys(this._countLabelAnomalies)
                                        .length + " LABEL "} */}
                                </strong>
                              </div>
                              <div className="pt-2 justify-content-end">
                                <span
                                  className={
                                    this.state._advanced_collapse_opened_ne ==
                                    false
                                      ? "icon-caret-down-outline"
                                      : "icon-caret-up-outline"
                                  }
                                ></span>
                              </div>
                            </div>
                          ) : (
                            <div className="pt-2 justify-content-end">
                              <strong>
                                {
                                  "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                }
                                {Object.keys(this._countProbNotEnough_gray)
                                  .length +
                                  " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                {this.getAppContext().platformName() ==
                                "WiFiProbe"
                                  ? Object.keys(this._countEssidNotEnough_gray)
                                      .length +
                                    " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                  : Object.keys(
                                      this._countMeasureNameNotEnough_gray,
                                    ).length +
                                    " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {"\u00A0"}
                                {this._notEnoughCount_gray != "0" && (
                                  <>
                                    Details
                                    <span
                                      className={
                                        this.state
                                          ._advanced_collapse_opened_ne == false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </>
                                )}
                              </strong>
                            </div>
                          )}
                        </Row>
                      </Col>
                    </div>
                  </div>

                  <ReactOCollapse
                    className="border-top border-2 border-gray"
                    onControllerReady={(_collapse_controller) => {
                      this._advanced_collapse_ne = _collapse_controller;
                      this.setState({
                        _advanced_collapse_opened_ne: false,
                      });
                    }}
                    onOpened={() => {
                      this.setState({ _advanced_collapse_opened_ne: true });
                    }}
                    onClosed={() => {
                      this.setState({
                        _advanced_collapse_opened_ne: false,
                      });
                    }}
                    // initOpen={this._notEnoughCount_gray > 0}
                    // initOpen={true}
                  >
                    {this.state.filteredData && (
                      <div>
                        <ReactOTable
                          thClassName="px-3 py-1"
                          tdClassName="align-middle px-3 py-2"
                          hoverable
                          compressedDark
                          compressed={this.getAppContext().media.isMobile}
                          thDividers
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "15",
                              sortable: true,
                            },
                            {
                              title: "MEASURE",
                              align: "center",
                              data_key: "measure",
                              width: "20",
                              sortable: true,
                            },
                            {
                              title: "TAGS",
                              align: "center",
                              data_key: "tags",
                              width: "30",
                              sortable: false,
                            },
                            {
                              title: "STATUS",
                              align: "center",
                              data_key: "status",
                              width: "15",
                              sortable: false,
                            },
                            {
                              title: "SINCE",
                              align: "center",
                              data_key: "since",
                              width: "15",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let data = [];

                            this.state.filteredData
                              .filter(
                                (d) => d.diag == "N" && d.explicit_mac == "no",
                              )
                              .forEach((d, id) => {
                                data.push({
                                  probe: {
                                    value: d.probeid,
                                    render: (
                                      <div
                                        onClick={() => {
                                          this.getAppContext()
                                            .getLocalStorageService()
                                            .set(
                                              "goBackExplorer",
                                              "/dashboard?tab=smart",
                                            );
                                        }}
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/" +
                                              d.probeid +
                                              "/active/" +
                                              d.cssid +
                                              "/" +
                                              (d.bssid != "-"
                                                ? d.bssid.replace(/:/g, "")
                                                : "overal"),
                                            state: {
                                              mlist,
                                              selectedTags:
                                                this.state.selectedTags,
                                            },
                                          }}
                                        >
                                          <strong> {d.probename} </strong>
                                          <div className="sub-title">
                                            {d.probeid
                                              .replace(/(..)/g, "$1:")
                                              .slice(0, -1)}
                                          </div>
                                        </Link>
                                      </div>
                                    ),
                                  },
                                  measure: {
                                    value: d.name,
                                    render: (
                                      <div
                                        onClick={() => {
                                          this.getAppContext()
                                            .getLocalStorageService()
                                            .set(
                                              "goBackExplorer",
                                              "/dashboard?tab=smart",
                                            );
                                        }}
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/" +
                                              d.probeid +
                                              "/active/" +
                                              d.cssid +
                                              "/" +
                                              (d.bssid != "-"
                                                ? d.bssid.replace(/:/g, "")
                                                : "overal"),
                                            state: {
                                              mlist,
                                              selectedTags:
                                                this.state.selectedTags,
                                            },
                                          }}
                                        >
                                          <strong>{d.name}</strong>
                                        </Link>
                                      </div>
                                    ),
                                  },
                                  tags: {
                                    value: d.tags,
                                    render: this.renderInlineTags(
                                      d.tags,
                                      this.state.selectedTags,
                                    ),
                                  },
                                  status: {
                                    value: d.status,
                                    render: (
                                      <div
                                        onClick={() => {
                                          this.getAppContext()
                                            .getLocalStorageService()
                                            .set(
                                              "goBackExplorer",
                                              "/dashboard?tab=smart",
                                            );
                                        }}
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/" +
                                              d.probeid +
                                              "/active/" +
                                              d.cssid +
                                              "/" +
                                              (d.bssid != "-"
                                                ? d.bssid.replace(/:/g, "")
                                                : "overal"),
                                            state: {
                                              mlist,
                                              selectedTags:
                                                this.state.selectedTags,
                                            },
                                          }}
                                        >
                                          <span
                                            className={
                                              d.last_state == "N" ||
                                              d.last_state == "U"
                                                ? "text-" +
                                                  this.getAppContext().conf
                                                    .MLY_STATES_DICTIONARY[
                                                    d.last_state
                                                  ].color
                                                : "text-" + d.color
                                            }
                                          >
                                            {
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[d.diag]
                                                .text
                                            }
                                          </span>
                                          {d.err_step ? (
                                            <div
                                              className={
                                                d.last_state == "N" ||
                                                d.last_state == "U"
                                                  ? "sub-title text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[
                                                      d.last_state
                                                    ].color
                                                  : "sub-title text-" + d.color
                                              }
                                            >
                                              {d.err_step &&
                                              d.err_step.length > 0
                                                ? d.err_step.substring(0, 2) ==
                                                  "MO"
                                                  ? "mostly on " +
                                                    d.err_step.substring(
                                                      3,
                                                      d.err_step.length,
                                                    )
                                                  : "on " +
                                                    d.err_step.substring(
                                                      3,
                                                      d.err_step.length,
                                                    )
                                                : null}
                                            </div>
                                          ) : null}
                                        </Link>
                                      </div>
                                    ),
                                  },
                                  since: {
                                    value: d.since,
                                    render: (
                                      <div
                                        onClick={() => {
                                          this.getAppContext()
                                            .getLocalStorageService()
                                            .set(
                                              "goBackExplorer",
                                              "/dashboard?tab=smart",
                                            );
                                        }}
                                      >
                                        <Link
                                          to={{
                                            pathname:
                                              "/" +
                                              d.probeid +
                                              "/active/" +
                                              d.cssid +
                                              "/" +
                                              (d.bssid != "-"
                                                ? d.bssid.replace(/:/g, "")
                                                : "overal"),
                                            state: {
                                              mlist,
                                              selectedTags:
                                                this.state.selectedTags,
                                            },
                                          }}
                                        >
                                          {this.getAppContext()
                                            .momentjs(d.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(d.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(d.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </Link>
                                      </div>
                                    ),
                                  },
                                });
                              });
                            return data;
                          })()}
                        ></ReactOTable>
                      </div>
                    )}
                  </ReactOCollapse>
                </Panel>
              </div>
            ) : null}
            <div className="d-flex mt-1 justify-content-between align-items-center">
              <div></div>

              <ReactOForm
                onControllerReady={(form_controller) => {
                  this.showTags_form = form_controller;
                }}
                onFormDataChange={(new_data) => {
                  if (new_data.showTags == "on") {
                    this.handleMeasuresWithoutTags("on");
                    this.setState({ showTags: false });
                  } else if (new_data.showTags == "off") {
                    this.handleMeasuresWithoutTags("off");
                    this.setState({ showTags: true });
                  }
                }}
              >
                {this.noTagCount && this.noTagCount == 0 ? (
                  <>
                    <strong
                      className="sub-title mr-2"
                      style={{ display: "inline-block" }}
                    >
                      {`Show ${this.noTagCount} measures with no tag`}
                      {/* Show untagged measures only - {this.noTagCount} */}
                    </strong>
                    <div style={{ display: "inline-block" }}>
                      <ReactOFormInput type="switch" data_key="showTags" />
                    </div>
                  </>
                ) : (
                  <strong
                    className="sub-title mr-2"
                    style={{ display: "inline-block" }}
                  >
                    0 measures with no tag
                  </strong>
                )}
              </ReactOForm>
            </div>
          </div>
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  //	Sites,
  withDefinedContext(SmartView, "Smart", context_exposed_methods),
  {
    retrieve: ["_LayoutSidebar"],
  },
);
